import { computeResourcesEmptyApi as api } from "./computeResources.empty-api";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClassesByClassId: build.query<
      GetClassesByClassIdApiResponse,
      GetClassesByClassIdApiArg
    >({
      query: (queryArg) => ({ url: `/classes/${queryArg.classId}` }),
    }),
    getClusters: build.query<GetClustersApiResponse, GetClustersApiArg>({
      query: () => ({ url: `/clusters` }),
    }),
    postClusters: build.mutation<PostClustersApiResponse, PostClustersApiArg>({
      query: (queryArg) => ({
        url: `/clusters`,
        method: "POST",
        body: queryArg.cluster,
      }),
    }),
    getClustersByClusterId: build.query<
      GetClustersByClusterIdApiResponse,
      GetClustersByClusterIdApiArg
    >({
      query: (queryArg) => ({ url: `/clusters/${queryArg.clusterId}` }),
    }),
    putClustersByClusterId: build.mutation<
      PutClustersByClusterIdApiResponse,
      PutClustersByClusterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/clusters/${queryArg.clusterId}`,
        method: "PUT",
        body: queryArg.cluster,
      }),
    }),
    patchClustersByClusterId: build.mutation<
      PatchClustersByClusterIdApiResponse,
      PatchClustersByClusterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/clusters/${queryArg.clusterId}`,
        method: "PATCH",
        body: queryArg.clusterPatch,
      }),
    }),
    deleteClustersByClusterId: build.mutation<
      DeleteClustersByClusterIdApiResponse,
      DeleteClustersByClusterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/clusters/${queryArg.clusterId}`,
        method: "DELETE",
      }),
    }),
    getError: build.query<GetErrorApiResponse, GetErrorApiArg>({
      query: () => ({ url: `/error` }),
    }),
    getResourcePools: build.query<
      GetResourcePoolsApiResponse,
      GetResourcePoolsApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools`,
        params: {
          resource_pools_params: queryArg.resourcePoolsParams,
        },
      }),
    }),
    postResourcePools: build.mutation<
      PostResourcePoolsApiResponse,
      PostResourcePoolsApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools`,
        method: "POST",
        body: queryArg.resourcePool,
      }),
    }),
    getResourcePoolsByResourcePoolId: build.query<
      GetResourcePoolsByResourcePoolIdApiResponse,
      GetResourcePoolsByResourcePoolIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}`,
      }),
    }),
    putResourcePoolsByResourcePoolId: build.mutation<
      PutResourcePoolsByResourcePoolIdApiResponse,
      PutResourcePoolsByResourcePoolIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}`,
        method: "PUT",
        body: queryArg.resourcePoolPut,
      }),
    }),
    patchResourcePoolsByResourcePoolId: build.mutation<
      PatchResourcePoolsByResourcePoolIdApiResponse,
      PatchResourcePoolsByResourcePoolIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}`,
        method: "PATCH",
        body: queryArg.resourcePoolPatch,
      }),
    }),
    deleteResourcePoolsByResourcePoolId: build.mutation<
      DeleteResourcePoolsByResourcePoolIdApiResponse,
      DeleteResourcePoolsByResourcePoolIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}`,
        method: "DELETE",
      }),
    }),
    getResourcePoolsByResourcePoolIdClasses: build.query<
      GetResourcePoolsByResourcePoolIdClassesApiResponse,
      GetResourcePoolsByResourcePoolIdClassesApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/classes`,
        params: {
          resource_class_params: queryArg.resourceClassParams,
        },
      }),
    }),
    postResourcePoolsByResourcePoolIdClasses: build.mutation<
      PostResourcePoolsByResourcePoolIdClassesApiResponse,
      PostResourcePoolsByResourcePoolIdClassesApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/classes`,
        method: "POST",
        body: queryArg.resourceClass,
      }),
    }),
    getResourcePoolsByResourcePoolIdClassesAndClassId: build.query<
      GetResourcePoolsByResourcePoolIdClassesAndClassIdApiResponse,
      GetResourcePoolsByResourcePoolIdClassesAndClassIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/classes/${queryArg.classId}`,
      }),
    }),
    putResourcePoolsByResourcePoolIdClassesAndClassId: build.mutation<
      PutResourcePoolsByResourcePoolIdClassesAndClassIdApiResponse,
      PutResourcePoolsByResourcePoolIdClassesAndClassIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/classes/${queryArg.classId}`,
        method: "PUT",
        body: queryArg.resourceClass,
      }),
    }),
    patchResourcePoolsByResourcePoolIdClassesAndClassId: build.mutation<
      PatchResourcePoolsByResourcePoolIdClassesAndClassIdApiResponse,
      PatchResourcePoolsByResourcePoolIdClassesAndClassIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/classes/${queryArg.classId}`,
        method: "PATCH",
        body: queryArg.resourceClassPatch,
      }),
    }),
    deleteResourcePoolsByResourcePoolIdClassesAndClassId: build.mutation<
      DeleteResourcePoolsByResourcePoolIdClassesAndClassIdApiResponse,
      DeleteResourcePoolsByResourcePoolIdClassesAndClassIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/classes/${queryArg.classId}`,
        method: "DELETE",
      }),
    }),
    getResourcePoolsByResourcePoolIdClassesAndClassIdTolerations: build.query<
      GetResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsApiResponse,
      GetResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/classes/${queryArg.classId}/tolerations`,
      }),
    }),
    deleteResourcePoolsByResourcePoolIdClassesAndClassIdTolerations:
      build.mutation<
        DeleteResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsApiResponse,
        DeleteResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsApiArg
      >({
        query: (queryArg) => ({
          url: `/resource_pools/${queryArg.resourcePoolId}/classes/${queryArg.classId}/tolerations`,
          method: "DELETE",
        }),
      }),
    getResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinities:
      build.query<
        GetResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesApiResponse,
        GetResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/resource_pools/${queryArg.resourcePoolId}/classes/${queryArg.classId}/node_affinities`,
        }),
      }),
    deleteResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinities:
      build.mutation<
        DeleteResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesApiResponse,
        DeleteResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/resource_pools/${queryArg.resourcePoolId}/classes/${queryArg.classId}/node_affinities`,
          method: "DELETE",
        }),
      }),
    getResourcePoolsByResourcePoolIdUsers: build.query<
      GetResourcePoolsByResourcePoolIdUsersApiResponse,
      GetResourcePoolsByResourcePoolIdUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/users`,
      }),
    }),
    postResourcePoolsByResourcePoolIdUsers: build.mutation<
      PostResourcePoolsByResourcePoolIdUsersApiResponse,
      PostResourcePoolsByResourcePoolIdUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/users`,
        method: "POST",
        body: queryArg.poolUsersWithId,
      }),
    }),
    putResourcePoolsByResourcePoolIdUsers: build.mutation<
      PutResourcePoolsByResourcePoolIdUsersApiResponse,
      PutResourcePoolsByResourcePoolIdUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/users`,
        method: "PUT",
        body: queryArg.poolUsersWithId,
      }),
    }),
    getResourcePoolsByResourcePoolIdUsersAndUserId: build.query<
      GetResourcePoolsByResourcePoolIdUsersAndUserIdApiResponse,
      GetResourcePoolsByResourcePoolIdUsersAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/users/${queryArg.userId}`,
      }),
    }),
    deleteResourcePoolsByResourcePoolIdUsersAndUserId: build.mutation<
      DeleteResourcePoolsByResourcePoolIdUsersAndUserIdApiResponse,
      DeleteResourcePoolsByResourcePoolIdUsersAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/users/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getResourcePoolsByResourcePoolIdMembers: build.query<
      GetResourcePoolsByResourcePoolIdMembersApiResponse,
      GetResourcePoolsByResourcePoolIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/members`,
      }),
    }),
    postResourcePoolsByResourcePoolIdMembers: build.mutation<
      PostResourcePoolsByResourcePoolIdMembersApiResponse,
      PostResourcePoolsByResourcePoolIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/members`,
        method: "POST",
        body: queryArg.poolMembers,
      }),
    }),
    putResourcePoolsByResourcePoolIdMembers: build.mutation<
      PutResourcePoolsByResourcePoolIdMembersApiResponse,
      PutResourcePoolsByResourcePoolIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/members`,
        method: "PUT",
        body: queryArg.poolMembers,
      }),
    }),
    getResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberId: build.query<
      GetResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdApiResponse,
      GetResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/members/${queryArg.memberType}/${queryArg.memberId}`,
      }),
    }),
    deleteResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberId:
      build.mutation<
        DeleteResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdApiResponse,
        DeleteResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdApiArg
      >({
        query: (queryArg) => ({
          url: `/resource_pools/${queryArg.resourcePoolId}/members/${queryArg.memberType}/${queryArg.memberId}`,
          method: "DELETE",
        }),
      }),
    getResourcePoolsByResourcePoolIdQuota: build.query<
      GetResourcePoolsByResourcePoolIdQuotaApiResponse,
      GetResourcePoolsByResourcePoolIdQuotaApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/quota`,
      }),
    }),
    putResourcePoolsByResourcePoolIdQuota: build.mutation<
      PutResourcePoolsByResourcePoolIdQuotaApiResponse,
      PutResourcePoolsByResourcePoolIdQuotaApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/quota`,
        method: "PUT",
        body: queryArg.quotaWithId,
      }),
    }),
    patchResourcePoolsByResourcePoolIdQuota: build.mutation<
      PatchResourcePoolsByResourcePoolIdQuotaApiResponse,
      PatchResourcePoolsByResourcePoolIdQuotaApiArg
    >({
      query: (queryArg) => ({
        url: `/resource_pools/${queryArg.resourcePoolId}/quota`,
        method: "PATCH",
        body: queryArg.quotaPatch,
      }),
    }),
    getUsersByUserIdResourcePools: build.query<
      GetUsersByUserIdResourcePoolsApiResponse,
      GetUsersByUserIdResourcePoolsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.userId}/resource_pools`,
        params: {
          user_resource_params: queryArg.userResourceParams,
        },
      }),
    }),
    postUsersByUserIdResourcePools: build.mutation<
      PostUsersByUserIdResourcePoolsApiResponse,
      PostUsersByUserIdResourcePoolsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.userId}/resource_pools`,
        method: "POST",
        body: queryArg.integerIds,
      }),
    }),
    putUsersByUserIdResourcePools: build.mutation<
      PutUsersByUserIdResourcePoolsApiResponse,
      PutUsersByUserIdResourcePoolsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.userId}/resource_pools`,
        method: "PUT",
        body: queryArg.integerIds,
      }),
    }),
    getGroupsByGroupSlugResourcePools: build.query<
      GetGroupsByGroupSlugResourcePoolsApiResponse,
      GetGroupsByGroupSlugResourcePoolsApiArg
    >({
      query: (queryArg) => ({
        url: `/groups/${queryArg.groupSlug}/resource_pools`,
      }),
    }),
    getVersion: build.query<GetVersionApiResponse, GetVersionApiArg>({
      query: () => ({ url: `/version` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as computeResourcesGeneratedApi };
export type GetClassesByClassIdApiResponse =
  /** status 200 The resource class that was requested */ ResourceClassWithId;
export type GetClassesByClassIdApiArg = {
  classId: string;
};
export type GetClustersApiResponse =
  /** status 200 The cluster configurations */ ClustersWithId;
export type GetClustersApiArg = void;
export type PostClustersApiResponse =
  /** status 201 The cluster configuration was created */ ClusterWithId;
export type PostClustersApiArg = {
  cluster: Cluster;
};
export type GetClustersByClusterIdApiResponse =
  /** status 200 The cluster configuration */ ClusterWithId;
export type GetClustersByClusterIdApiArg = {
  clusterId: Ulid;
};
export type PutClustersByClusterIdApiResponse =
  /** status 200 The cluster configuration */ ClusterWithId;
export type PutClustersByClusterIdApiArg = {
  clusterId: Ulid;
  cluster: Cluster;
};
export type PatchClustersByClusterIdApiResponse =
  /** status 200 The cluster configuration */ ClusterWithId;
export type PatchClustersByClusterIdApiArg = {
  clusterId: Ulid;
  clusterPatch: ClusterPatch;
};
export type DeleteClustersByClusterIdApiResponse = unknown;
export type DeleteClustersByClusterIdApiArg = {
  clusterId: Ulid;
};
export type GetErrorApiResponse = unknown;
export type GetErrorApiArg = void;
export type GetResourcePoolsApiResponse =
  /** status 200 The resource pool definitions */ ResourcePoolsWithIdFiltered;
export type GetResourcePoolsApiArg = {
  /** query parameters */
  resourcePoolsParams?: {
    cpu?: CpuFilter;
    gpu?: Gpu;
    memory?: MemoryFilter;
    max_storage?: StorageFilter;
  };
};
export type PostResourcePoolsApiResponse =
  /** status 201 The resource pool was created */ ResourcePoolWithId;
export type PostResourcePoolsApiArg = {
  resourcePool: ResourcePool;
};
export type GetResourcePoolsByResourcePoolIdApiResponse =
  /** status 200 The resource pool definition */ ResourcePoolWithId;
export type GetResourcePoolsByResourcePoolIdApiArg = {
  resourcePoolId: number;
};
export type PutResourcePoolsByResourcePoolIdApiResponse =
  /** status 200 The resource pool definition */ ResourcePoolWithId;
export type PutResourcePoolsByResourcePoolIdApiArg = {
  resourcePoolId: number;
  resourcePoolPut: ResourcePoolPut;
};
export type PatchResourcePoolsByResourcePoolIdApiResponse =
  /** status 200 The resource pool definition */ ResourcePoolWithId;
export type PatchResourcePoolsByResourcePoolIdApiArg = {
  resourcePoolId: number;
  resourcePoolPatch: ResourcePoolPatch;
};
export type DeleteResourcePoolsByResourcePoolIdApiResponse = unknown;
export type DeleteResourcePoolsByResourcePoolIdApiArg = {
  resourcePoolId: number;
};
export type GetResourcePoolsByResourcePoolIdClassesApiResponse =
  /** status 200 The resource class in the specific pool */ ResourceClassesWithIdResponse;
export type GetResourcePoolsByResourcePoolIdClassesApiArg = {
  resourcePoolId: number;
  /** Filter for resource classes based on the provided name as a prefix. Omitting this parameter returns all classes. */
  resourceClassParams?: {
    name?: Name;
  };
};
export type PostResourcePoolsByResourcePoolIdClassesApiResponse =
  /** status 201 Created a class in the resource pool */ ResourceClassWithId;
export type PostResourcePoolsByResourcePoolIdClassesApiArg = {
  resourcePoolId: number;
  resourceClass: ResourceClass;
};
export type GetResourcePoolsByResourcePoolIdClassesAndClassIdApiResponse =
  /** status 200 The resource class that was requested */ ResourceClassWithId;
export type GetResourcePoolsByResourcePoolIdClassesAndClassIdApiArg = {
  resourcePoolId: number;
  classId: string;
};
export type PutResourcePoolsByResourcePoolIdClassesAndClassIdApiResponse =
  /** status 200 Updated the classes in the resource pool */ ResourceClassWithId;
export type PutResourcePoolsByResourcePoolIdClassesAndClassIdApiArg = {
  resourcePoolId: number;
  classId: string;
  resourceClass: ResourceClass;
};
export type PatchResourcePoolsByResourcePoolIdClassesAndClassIdApiResponse =
  /** status 200 Updated the classes in the resource pool */ ResourceClassWithId;
export type PatchResourcePoolsByResourcePoolIdClassesAndClassIdApiArg = {
  resourcePoolId: number;
  classId: string;
  resourceClassPatch: ResourceClassPatch;
};
export type DeleteResourcePoolsByResourcePoolIdClassesAndClassIdApiResponse =
  unknown;
export type DeleteResourcePoolsByResourcePoolIdClassesAndClassIdApiArg = {
  resourcePoolId: number;
  classId: string;
};
export type GetResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsApiResponse =
  /** status 200 All the tolerations for a resource class */ K8SLabelList;
export type GetResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsApiArg =
  {
    resourcePoolId: number;
    classId: string;
  };
export type DeleteResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsApiResponse =
  unknown;
export type DeleteResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsApiArg =
  {
    resourcePoolId: number;
    classId: string;
  };
export type GetResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesApiResponse =
  /** status 200 All the affinities for a resource class */ NodeAffinityListResponse;
export type GetResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesApiArg =
  {
    resourcePoolId: number;
    classId: string;
  };
export type DeleteResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesApiResponse =
  unknown;
export type DeleteResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesApiArg =
  {
    resourcePoolId: number;
    classId: string;
  };
export type GetResourcePoolsByResourcePoolIdUsersApiResponse =
  /** status 200 The list of users */ PoolUsersWithId;
export type GetResourcePoolsByResourcePoolIdUsersApiArg = {
  resourcePoolId: number;
};
export type PostResourcePoolsByResourcePoolIdUsersApiResponse =
  /** status 201 The list of users was updated */ PoolUsersWithId;
export type PostResourcePoolsByResourcePoolIdUsersApiArg = {
  resourcePoolId: number;
  /** List of user Ids */
  poolUsersWithId: PoolUsersWithId;
};
export type PutResourcePoolsByResourcePoolIdUsersApiResponse =
  /** status 200 The list of users was updated */ PoolUsersWithId;
export type PutResourcePoolsByResourcePoolIdUsersApiArg = {
  resourcePoolId: number;
  /** List of user Ids */
  poolUsersWithId: PoolUsersWithId;
};
export type GetResourcePoolsByResourcePoolIdUsersAndUserIdApiResponse =
  /** status 200 The user belongs to the resource pool */ PoolUserWithId;
export type GetResourcePoolsByResourcePoolIdUsersAndUserIdApiArg = {
  resourcePoolId: number;
  userId: string;
};
export type DeleteResourcePoolsByResourcePoolIdUsersAndUserIdApiResponse =
  unknown;
export type DeleteResourcePoolsByResourcePoolIdUsersAndUserIdApiArg = {
  resourcePoolId: number;
  userId: string;
};
export type GetResourcePoolsByResourcePoolIdMembersApiResponse =
  /** status 200 The list of members */ PoolMembersResponse;
export type GetResourcePoolsByResourcePoolIdMembersApiArg = {
  resourcePoolId: number;
};
export type PostResourcePoolsByResourcePoolIdMembersApiResponse =
  /** status 201 The members were added */ PoolMembersResponse;
export type PostResourcePoolsByResourcePoolIdMembersApiArg = {
  resourcePoolId: number;
  /** List of members */
  poolMembers: PoolMembers;
};
export type PutResourcePoolsByResourcePoolIdMembersApiResponse =
  /** status 200 The members were set */ PoolMembersResponse;
export type PutResourcePoolsByResourcePoolIdMembersApiArg = {
  resourcePoolId: number;
  /** List of members */
  poolMembers: PoolMembers;
};
export type GetResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdApiResponse =
  /** status 200 The member belongs to the resource pool */ PoolMemberResponse;
export type GetResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdApiArg =
  {
    resourcePoolId: number;
    memberType: "user" | "group" | "project";
    memberId: string;
  };
export type DeleteResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdApiResponse =
  unknown;
export type DeleteResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdApiArg =
  {
    resourcePoolId: number;
    memberType: "user" | "group" | "project";
    memberId: string;
  };
export type GetResourcePoolsByResourcePoolIdQuotaApiResponse =
  /** status 200 The resource quota for the resource pool */ QuotaWithId;
export type GetResourcePoolsByResourcePoolIdQuotaApiArg = {
  resourcePoolId: number;
};
export type PutResourcePoolsByResourcePoolIdQuotaApiResponse =
  /** status 200 The quota has been updated */ QuotaWithId;
export type PutResourcePoolsByResourcePoolIdQuotaApiArg = {
  resourcePoolId: number;
  quotaWithId: QuotaWithId;
};
export type PatchResourcePoolsByResourcePoolIdQuotaApiResponse =
  /** status 200 The quota has been updated */ QuotaWithId;
export type PatchResourcePoolsByResourcePoolIdQuotaApiArg = {
  resourcePoolId: number;
  quotaPatch: QuotaPatch;
};
export type GetUsersByUserIdResourcePoolsApiResponse =
  /** status 200 The resource pools that the user has access to */ ResourcePoolsWithId;
export type GetUsersByUserIdResourcePoolsApiArg = {
  userId: string;
  /** Filter for resource classes based on the provided name as a prefix. Omitting this parameter returns all classes. */
  userResourceParams?: {
    name?: Name;
  };
};
export type PostUsersByUserIdResourcePoolsApiResponse =
  /** status 201 The resource pools that the user has been given access to */ ResourcePoolsWithId;
export type PostUsersByUserIdResourcePoolsApiArg = {
  userId: string;
  /** List of resource pool IDs */
  integerIds: IntegerIds;
};
export type PutUsersByUserIdResourcePoolsApiResponse =
  /** status 200 The resource pools that the user has been given access to */ ResourcePoolsWithId;
export type PutUsersByUserIdResourcePoolsApiArg = {
  userId: string;
  /** List of resource pool IDs */
  integerIds: IntegerIds;
};
export type GetGroupsByGroupSlugResourcePoolsApiResponse =
  /** status 200 The resource pools that the group has access to */ ResourcePoolsWithIdFiltered;
export type GetGroupsByGroupSlugResourcePoolsApiArg = {
  groupSlug: string;
};
export type GetVersionApiResponse = /** status 200 The error */ Version;
export type GetVersionApiArg = void;
export type Name = string;
export type DefaultFlag = boolean;
export type Cpu = number;
export type Memory = number;
export type Gpu = number;
export type Storage = number;
export type K8SLabel = string;
export type K8SLabelList = K8SLabel[];
export type NodeAffinity = {
  key: K8SLabel;
  required_during_scheduling?: boolean;
};
export type NodeAffinityList = NodeAffinity[];
export type IntegerId = number;
export type QuotaEnforced = boolean;
export type RemoteConfigurationFirecrestSystemName = string;
export type RemoteConfigurationFirecrestPartition = string;
export type RemoteClassConfigurationFirecrest = {
  system_name?: RemoteConfigurationFirecrestSystemName;
  partition?: RemoteConfigurationFirecrestPartition;
  /** When true, Amalthea forwards the resource class CPU, memory, and GPU values to FirecREST. When false (the default), the HPC grid selects the resources; the class values are still used for display and quota matching.
   */
  forward_resource_values?: boolean;
};
export type ResourceClassWithId = {
  name: Name;
  default: DefaultFlag;
  cpu: Cpu;
  memory: Memory;
  gpu: Gpu;
  max_storage: Storage;
  default_storage: Storage;
  tolerations?: K8SLabelList;
  node_affinities?: NodeAffinityList;
  id: IntegerId;
  quota_enforced?: QuotaEnforced;
  remote?: RemoteClassConfigurationFirecrest;
};
export type ErrorResponse = {
  error: {
    code: number;
    detail?: string;
    message: string;
    /** Sentry trace ID for linking to corresponding log entries */
    trace_id?: string;
  };
};
export type ConfigName = string;
export type Ulid = string;
export type Protocol = "http" | "https";
export type Host = string;
export type Port = number;
export type IngressClassName = string;
export type IngressAnnotations = {
  [key: string]: any;
};
export type TlsSecretName = string;
export type StorageClassName = string;
export type ClusterWithId = {
  name: Name;
  config_name: ConfigName;
  id: Ulid;
  session_protocol: Protocol;
  session_host: Host;
  session_port: Port;
  session_path: string;
  session_ingress_class_name?: IngressClassName;
  session_ingress_annotations: IngressAnnotations;
  session_tls_secret_name?: TlsSecretName;
  session_storage_class?: StorageClassName;
  service_account_name?: string;
  session_ingress_use_default_cluster_tls_cert: boolean;
};
export type ClustersWithId = ClusterWithId[];
export type K8SResourceName = string;
export type Cluster = {
  name: Name;
  config_name: ConfigName;
  session_protocol: Protocol;
  session_host: Host;
  session_port: Port;
  session_path: string;
  session_ingress_class_name?: IngressClassName;
  session_ingress_annotations: IngressAnnotations;
  session_tls_secret_name?: TlsSecretName;
  session_storage_class?: StorageClassName;
  service_account_name?: K8SResourceName;
  session_ingress_use_default_cluster_tls_cert?: boolean;
};
export type K8SResourceNamePatch = string;
export type ClusterPatch = {
  name?: Name;
  config_name?: ConfigName;
  session_protocol?: Protocol;
  session_host?: Host;
  session_port?: Port;
  session_path?: string;
  session_ingress_class_name?: IngressClassName;
  session_ingress_annotations?: IngressAnnotations;
  session_tls_secret_name?: TlsSecretName & any;
  session_storage_class?: StorageClassName;
  service_account_name?: K8SResourceNamePatch;
  session_ingress_use_default_cluster_tls_cert?: boolean;
};
export type QuotaWithId = {
  cpu: Cpu;
  memory: Memory;
  gpu: Gpu;
  id: Name;
};
export type UsageHoursRemaining = number;
export type UsageHoursTotal = number;
export type ResourceClassWithIdFiltered = ResourceClassWithId & {
  matching?: boolean;
  usage_hours_remaining?: UsageHoursRemaining;
  usage_hours_total?: UsageHoursTotal;
};
export type PublicFlag = boolean;
export type RemoteConfigurationFirecrestProviderId = string;
export type RemoteConfigurationFirecrestApiUrl = string;
export type RemoteConfigurationFirecrest = {
  /** Kind of remote resource pool */
  kind: "firecrest";
  provider_id?: RemoteConfigurationFirecrestProviderId;
  api_url: RemoteConfigurationFirecrestApiUrl;
  system_name: RemoteConfigurationFirecrestSystemName;
  partition?: RemoteConfigurationFirecrestPartition;
};
export type RemoteConfigurationRunaiApiUrl = string;
export type RemoteConfigurationRunai = {
  /** Kind of remote resource pool */
  kind: "runai";
  base_url: RemoteConfigurationRunaiApiUrl;
  provider_id?: RemoteConfigurationFirecrestProviderId;
};
export type RemoteConfiguration =
  | RemoteConfigurationFirecrest
  | RemoteConfigurationRunai;
export type IdleThreshold = number;
export type HibernationThreshold = number;
export type HibernationWarningPeriod = number;
export type RuntimePlatform = "linux/amd64" | "linux/arm64";
export type CreditsUsed = number;
export type CpuLimitFactor = number;
export type ResourcePoolWithIdFiltered = {
  quota?: QuotaWithId;
  classes: ResourceClassWithIdFiltered[];
  name: Name;
  id: IntegerId;
  public: PublicFlag;
  default: DefaultFlag;
  remote?: RemoteConfiguration;
  idle_threshold?: IdleThreshold;
  hibernation_threshold?: HibernationThreshold;
  hibernation_warning_period?: HibernationWarningPeriod;
  cluster_id?: Ulid;
  platform: RuntimePlatform;
  credits_used?: CreditsUsed;
  cpu_limit_factor?: CpuLimitFactor;
};
export type ResourcePoolsWithIdFiltered = ResourcePoolWithIdFiltered[];
export type CpuFilter = number;
export type MemoryFilter = number;
export type StorageFilter = number;
export type ResourcePoolWithId = {
  quota?: QuotaWithId;
  classes: ResourceClassWithId[];
  name: Name;
  id: IntegerId;
  public: PublicFlag;
  default: DefaultFlag;
  remote?: RemoteConfiguration;
  idle_threshold?: IdleThreshold;
  hibernation_threshold?: HibernationThreshold;
  hibernation_warning_period?: HibernationWarningPeriod;
  cluster?: {
    id: Ulid;
  };
  platform: RuntimePlatform;
  cpu_limit_factor?: CpuLimitFactor;
};
export type QuotaWithOptionalId = {
  cpu: Cpu;
  memory: Memory;
  gpu: Gpu;
  id?: Name;
};
export type ResourceClass = {
  name: Name;
  default: DefaultFlag;
  cpu: Cpu;
  memory: Memory;
  gpu: Gpu;
  max_storage: Storage;
  default_storage: Storage;
  tolerations?: K8SLabelList;
  node_affinities?: NodeAffinityList;
  quota_enforced?: QuotaEnforced;
  remote?: RemoteClassConfigurationFirecrest;
};
export type ResourceClasses = ResourceClass[];
export type ResourcePool = {
  quota?: QuotaWithOptionalId;
  classes: ResourceClasses;
  name: Name;
  public: PublicFlag;
  default: DefaultFlag;
  remote?: RemoteConfiguration;
  idle_threshold?: IdleThreshold;
  hibernation_threshold?: HibernationThreshold;
  hibernation_warning_period?: HibernationWarningPeriod;
  cluster_id?: Ulid;
  platform?: RuntimePlatform;
  cpu_limit_factor?: CpuLimitFactor;
};
export type ResourceClassesWithId = ResourceClassWithId[];
export type RemoveCpuLimitFactor = number;
export type ResourcePoolPut = {
  quota?: QuotaWithId;
  classes: ResourceClassesWithId;
  name: Name;
  public: PublicFlag;
  default: DefaultFlag;
  remote?: RemoteConfiguration;
  idle_threshold?: IdleThreshold;
  hibernation_threshold?: HibernationThreshold;
  hibernation_warning_period?: HibernationWarningPeriod;
  cluster_id?: Ulid;
  platform: RuntimePlatform;
  cpu_limit_factor?: CpuLimitFactor | RemoveCpuLimitFactor;
};
export type QuotaPatch = {
  cpu?: Cpu;
  memory?: Memory;
  gpu?: Gpu;
};
export type ResourceClassProperties = {
  name?: Name;
  default?: DefaultFlag;
  cpu?: Cpu;
  memory?: Memory;
  gpu?: Gpu;
  max_storage?: Storage;
  default_storage?: Storage;
  tolerations?: K8SLabelList;
  node_affinities?: NodeAffinityList;
  quota_enforced?: QuotaEnforced;
  remote?: RemoteClassConfigurationFirecrest;
};
export type ResourceClassPatchWithId = ResourceClassProperties & {
  id: IntegerId;
};
export type ResourceClassesPatchWithId = ResourceClassPatchWithId[];
export type RemoteConfigurationPatchReset = object;
export type RemoteConfigurationFirecrestPatch = {
  /** Kind of remote resource pool */
  kind?: "firecrest";
  provider_id?: RemoteConfigurationFirecrestProviderId;
  api_url?: RemoteConfigurationFirecrestApiUrl;
  system_name?: RemoteConfigurationFirecrestSystemName;
  partition?: RemoteConfigurationFirecrestPartition;
};
export type RemoteConfigurationRunaiPatch = {
  /** Kind of remote resource pool */
  kind?: "runai";
  base_url?: RemoteConfigurationRunaiApiUrl;
  provider_id?: RemoteConfigurationFirecrestProviderId;
};
export type RemoteConfigurationPatch =
  | RemoteConfigurationPatchReset
  | RemoteConfigurationFirecrestPatch
  | RemoteConfigurationRunaiPatch;
export type ResourcePoolPatch = {
  quota?: QuotaPatch;
  classes?: ResourceClassesPatchWithId;
  name?: Name;
  public?: PublicFlag;
  default?: DefaultFlag;
  remote?: RemoteConfigurationPatch;
  idle_threshold?: IdleThreshold;
  hibernation_threshold?: HibernationThreshold;
  hibernation_warning_period?: HibernationWarningPeriod;
  cluster_id?: Ulid;
  platform?: RuntimePlatform;
  cpu_limit_factor?: CpuLimitFactor | RemoveCpuLimitFactor;
};
export type ResourceClassesWithIdResponse = ResourceClassWithId[];
export type ResourceClassPatch = ResourceClassProperties;
export type NodeAffinityListResponse = NodeAffinity[];
export type UserId = string;
export type PoolUserWithId = {
  id: UserId;
  /** If set to true the user will not be able to use the default resource pool */
  no_default_access?: boolean;
};
export type PoolUsersWithId = PoolUserWithId[];
export type PoolMemberUserResponse = {
  member_type: "user";
  id: UserId;
  role: "viewer" | "prohibited";
  email: string;
};
export type PoolMemberGroupResponse = {
  member_type: "group";
  id: Ulid;
  role: "group_viewer";
  slug: string;
  name: string;
};
export type PoolMemberProjectResponse = {
  member_type: "project";
  id: Ulid;
  role: "project_viewer";
  /** Full project namespace path (e.g. user/project) */
  namespace: string;
  name: string;
};
export type PoolMemberResponse =
  | PoolMemberUserResponse
  | PoolMemberGroupResponse
  | PoolMemberProjectResponse;
export type PoolMembersResponse = PoolMemberResponse[];
export type PoolMemberUser = {
  member_type: "user";
  id: UserId;
  role: "viewer" | "prohibited";
};
export type PoolMemberGroup = {
  member_type: "group";
  id: Ulid;
  role: "group_viewer";
};
export type PoolMemberProject = {
  member_type: "project";
  id: Ulid;
  role: "project_viewer";
};
export type PoolMember = PoolMemberUser | PoolMemberGroup | PoolMemberProject;
export type PoolMembers = PoolMember[];
export type ResourcePoolsWithId = ResourcePoolWithId[];
export type IntegerIds = IntegerId[];
export type Version = {
  version: string;
};
export const {
  useGetClassesByClassIdQuery,
  useGetClustersQuery,
  usePostClustersMutation,
  useGetClustersByClusterIdQuery,
  usePutClustersByClusterIdMutation,
  usePatchClustersByClusterIdMutation,
  useDeleteClustersByClusterIdMutation,
  useGetErrorQuery,
  useGetResourcePoolsQuery,
  usePostResourcePoolsMutation,
  useGetResourcePoolsByResourcePoolIdQuery,
  usePutResourcePoolsByResourcePoolIdMutation,
  usePatchResourcePoolsByResourcePoolIdMutation,
  useDeleteResourcePoolsByResourcePoolIdMutation,
  useGetResourcePoolsByResourcePoolIdClassesQuery,
  usePostResourcePoolsByResourcePoolIdClassesMutation,
  useGetResourcePoolsByResourcePoolIdClassesAndClassIdQuery,
  usePutResourcePoolsByResourcePoolIdClassesAndClassIdMutation,
  usePatchResourcePoolsByResourcePoolIdClassesAndClassIdMutation,
  useDeleteResourcePoolsByResourcePoolIdClassesAndClassIdMutation,
  useGetResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsQuery,
  useDeleteResourcePoolsByResourcePoolIdClassesAndClassIdTolerationsMutation,
  useGetResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesQuery,
  useDeleteResourcePoolsByResourcePoolIdClassesAndClassIdNodeAffinitiesMutation,
  useGetResourcePoolsByResourcePoolIdUsersQuery,
  usePostResourcePoolsByResourcePoolIdUsersMutation,
  usePutResourcePoolsByResourcePoolIdUsersMutation,
  useGetResourcePoolsByResourcePoolIdUsersAndUserIdQuery,
  useDeleteResourcePoolsByResourcePoolIdUsersAndUserIdMutation,
  useGetResourcePoolsByResourcePoolIdMembersQuery,
  usePostResourcePoolsByResourcePoolIdMembersMutation,
  usePutResourcePoolsByResourcePoolIdMembersMutation,
  useGetResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdQuery,
  useDeleteResourcePoolsByResourcePoolIdMembersAndMemberTypeMemberIdMutation,
  useGetResourcePoolsByResourcePoolIdQuotaQuery,
  usePutResourcePoolsByResourcePoolIdQuotaMutation,
  usePatchResourcePoolsByResourcePoolIdQuotaMutation,
  useGetUsersByUserIdResourcePoolsQuery,
  usePostUsersByUserIdResourcePoolsMutation,
  usePutUsersByUserIdResourcePoolsMutation,
  useGetGroupsByGroupSlugResourcePoolsQuery,
  useGetVersionQuery,
} = injectedRtkApi;
